






































































































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { getBirthday } from "@/services/dateTime/date-time-fofmat";
import { IHotelInfo, IUpdateHistory as IH } from "@/@types/hotel-info/info";
import { IGuest } from "@/@types/admin/guest/user";

import ButtonBoxArrowLeft from "@/components/buttons/button-box-arrow-left.vue";

@Component({ components: { ButtonBoxArrowLeft } })
export default class HistoryHotelInfoGraph extends Vue {
  @Inject("backgroundFolder") readonly backgroundFolder!: string;
  @Inject("imageFolder") readonly imageFolder!: string;
  @Prop({ type: Object, default: null }) hotelInfo!: IHotelInfo;
  @Prop({ type: Array, default: () => [] }) users!: Array<IGuest>;

  active = 0;

  get history(): Array<Partial<IH>> {
    return this.hotelInfo && this.hotelInfo.update_history
      ? this.hotelInfo.update_history.reverse()
      : [];
  }

  getManager(id: string): IGuest | null {
    const user = this.users.find((el: IGuest) => el._id == id);
    return user ? user : null;
  }

  getDate(date: Date): string {
    return getBirthday(date);
  }

  destroyed(): void {
    this.active = 0;
  }
}
